export enum LookingForOptionsEnum {
	Friends = '32536de9-551b-4ff7-a694-5c07153092c4',
	WorkoutBuddies = '719c4853-5be9-44c9-a22c-dbc503af28ce',
	Trainers = '9758d91c-4735-408e-8f00-fd8f0d8b82d9',
	Trainees = '2d5d6782-965c-47e7-9b34-7b9d7728f409',
	Advice = 'f260cf9d-ae32-4fc6-be52-f8b8ca1084bf',
	OpenForDating = '23add617-ab50-4db5-aa9c-0f14e035eb5d',
}
